// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.estimate-comparison-analysis[data-v-c15fedf8] {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 10px;
}
.estimate-comparison-analysis .header[data-v-c15fedf8] {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}
.estimate-comparison-analysis .header .header-left[data-v-c15fedf8] {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/views/DesignBudgetSoftware/TwoEstimateComparisonAnalysis/index.vue","webpack://./index.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;ACAF;ADPA;EASI,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,WAAA;ACCJ;ADbA;EAcM,OAAA;EACA,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,SAAA;ACEN","sourcesContent":["\n.estimate-comparison-analysis {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  gap: 10px;\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    width: 100%;\n    .header-left {\n      flex: 1;\n      display: flex;\n      justify-content: flex-start;\n      align-items: flex-start;\n      gap: 10px;\n    }\n  }\n}\n",".estimate-comparison-analysis {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  gap: 10px;\n}\n.estimate-comparison-analysis .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n}\n.estimate-comparison-analysis .header .header-left {\n  flex: 1;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
